import { render, staticRenderFns } from "./ExaminList.vue?vue&type=template&id=c81fe3f4&scoped=true&"
import script from "./ExaminList.vue?vue&type=script&lang=js&"
export * from "./ExaminList.vue?vue&type=script&lang=js&"
import style0 from "./ExaminList.vue?vue&type=style&index=0&id=c81fe3f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81fe3f4",
  null
  
)

export default component.exports